<!-- 没有遮罩的dialog -->
<style scoped lang="less">
  .login-modal-x {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 40px;
  }

  .login-content-x {
    width: 100%;
    padding: 20px;
    background-color: #fff;
    border-radius: 10px;
    background-position: top center;
    background-size: 100% auto;
    background-repeat: no-repeat;
    position: relative;
    z-index: 2;
  }

  .login-title {
    color: #333;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
  }

  .form-x {
    margin: 20px 0;
  }

  .form-item-x {
    border: 1px solid #f5f5f5;
    border-radius: 10px;

    & + & {
      margin-top: 10px;
    }
  }

  .field-btn {
    color: #333;
    text-align: right;
    font-size: 14px;
    font-weight: 400;
  }

  .xy-box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;

    .p-xy {
      font-size: 10px;
      color: #5e5e5e;

      .xy {
        color: #4782ed;
      }
    }
  }

  .close-icon {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    border: 2px solid;
    color: #adadad;
    font-size: 16px;
    margin-top: 20px;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      width: 2px;
      background-color: #adadad;
      height: 25px;
      top: 0;
      left: 50%;
      transform: translate(-50%, -100%);
    }
  }
  .form-text {
    margin-top: 6px;

    text-align: right;
    color: #999999;
    font-family: 'PingFang SC';
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
  }
</style>

<template>
  <div class="login-modal-x">
    <div
      class="login-content-x"
      :style="{ backgroundImage: `url(${imgBaseUrl}/v1.0.1/login-bg.png)` }"
    >
      <div class="login-title">欢迎登录</div>

      <van-tabs v-model:active="active" background="transparent" @click-tab="onClickTab">
        <van-tab title="手机验证码登陆">
          <div class="form-x">
            <van-form>
              <div class="form-item-x">
                <van-field
                  v-model="phone"
                  clearable
                  placeholder="请输入您的手机号"
                  :maxlength="11"
                />
              </div>
              <div class="form-item-x">
                <van-field
                  v-model="codeInfo.codeValue"
                  clearable
                  placeholder="请输入验证码"
                  :maxlength="6"
                >
                  <template #button>
                    <van-loading
                      v-if="codeInfo.isGetCode"
                      type="spinner"
                      color="var(--primaryColor)"
                      size="14px"
                    >
                      获取中...
                    </van-loading>
                    <div v-else class="field-btn" @click="getCode">
                      {{ codeInfo.tipText }}
                    </div>
                  </template>
                </van-field>
              </div>
            </van-form>
          </div>
        </van-tab>
        <van-tab title="密码登陆">
          <div class="form-x">
            <van-form>
              <div class="form-item-x">
                <van-field
                  v-model="phone"
                  clearable
                  placeholder="请输入您的手机号"
                  :maxlength="11"
                />
              </div>
              <div class="form-item-x">
                <van-field
                  :type="showPwd ? 'password' : 'text'"
                  v-model="password"
                  clearable
                  placeholder="请输入密码"
                >
                  <template #button>
                    <van-icon
                      :name="showPwd ? 'eye-o' : 'closed-eye'"
                      class="pwd-icon"
                      @click="showPwd = !showPwd"
                    />
                  </template>
                </van-field>
              </div>
            </van-form>
            <div class="form-text">
              <span @click="handlePassword">忘记密码</span>
            </div>
          </div>
        </van-tab>
      </van-tabs>

      <div class="xy-box">
        <van-checkbox
          v-model="checked"
          icon-size="14px"
          checked-color="#4782ED"
          style="margin-right: 5px"
        ></van-checkbox>
        <p class="p-xy">
          <span>我已阅读并同意</span>
          <span
            v-for="(item, index) in agreementList"
            :key="index"
            class="xy"
            @click="viewAgreement(item)"
          >
            {{ item.name }}
          </span>
        </p>
      </div>
      <div class="login-btn-x">
        <van-button type="primary" block round @click="confirm">确认登录</van-button>
      </div>
    </div>
    <div class="close-icon">
      <van-icon name="cross" @click="cancelModel" />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { AgreementItem, useSmsCode } from '@/hooks';
  import { showToast } from 'vant';
  import { checkPhone } from '@/utils/utils';
  import { getUserDetail, loginPassword, loginWithCode, userSignAgreement } from '@/api/basic';
  import { useLoginDialog } from '@/store';
  import { storage } from '@/utils/storage';
  import { buriedPointHook } from '@/hooks/buriedPoint';
  import router from '@/router';

  defineOptions({ name: 'LoginDialog' });
  const props = withDefaults(defineProps<{ agreementList?: AgreementItem[] }>(), {
    agreementList: () => [],
  });
  const emits = defineEmits<{
    (e: 'cancelModel'): void;
    (e: 'confirm'): void;
    (e: 'viewAgreement', item: AgreementItem): void;
  }>();
  const imgBaseUrl = inject('imgBaseUrl');
  const loginDialogProps = useLoginDialog();
  const { codeInfo, getSmsCode, initCodeInfo } = useSmsCode();
  const { buriedOperationFn } = buriedPointHook();
  const checked = ref(false);
  const phone = ref('');
  const password = ref('');
  const active = ref<string>('1');
  // 密码显示状态：false=隐藏（默认），true=显示
  const showPwd = ref(false);
  const getCode = () => {
    if (!phone.value) return showToast('请填写手机号码');
    if (!checkPhone(phone.value)) return showToast('请填写正确的手机号码');
    getSmsCode({
      userPhone: phone.value,
      scene: 4,
      sendPlatform: 4,
    });
  };

  const viewAgreement = (item: AgreementItem) => emits('viewAgreement', item);
  const cancelModel = () => emits('cancelModel');
  let isLoadLogin = false;
  const confirm = () => {
    // console.log('=======>', );
    // active.value 0-验证码 1-手机号

    if (isLoadLogin) return;
    if (!phone.value) return showToast('请填写手机号码');
    if (!checkPhone(phone.value)) return showToast('请填写正确的手机号码');
    if (!codeInfo.codeValue && active.value == '0') return showToast('请填写验证码');
    if (!checked.value) return showToast('请勾选协议');
    isLoadLogin = true;

    if (active.value == '1') {
      loginPassword(
        Object.assign(
          {
            phone: phone.value,
            password: password.value,
            // loginType: 2, // 使用弹窗登录，和查询报告直接登录区分
          },
          loginDialogProps.loginParams
        )
      )
        .then((res) => {
          showToast('登录成功');
          const token = res ? res.token : undefined;
          token && storage.setItem('token', token, null);
          // 获取用户信息
          getUserDetail().then((resData) => {
            // 登录之后以是否是代理来判断isAgent 展示个人还是代理人
            storage.setItem('isAgentPerson', resData.isAgent, null);
            // loginDialogProps.setIsAgentPerson(resData.isAgent);
            loginDialogProps.toLogin();
          });
          //
          let xyIds = props.agreementList.reduce((pre, cur) => pre + cur.id + ',', '');
          userSignAgreement({
            // signingScene: 5,
            signingScene: '3',
            agreementIds: xyIds.slice(1),
          });
          loginDialogProps.addLoginParams({ registerAgentFlag: 0 });
          isLoadLogin = false;
          // loginDialogProps.setIsLogin(true);
          // loginDialogProps.executeEvent('afterLogin');
          emits('confirm');
          console.log('=========================>getUserInfo', res);
        })
        .catch(() => {
          isLoadLogin = false;
        });
    } else {
      loginWithCode(
        Object.assign(
          {
            userPhone: phone.value,
            code: codeInfo.codeValue,
            // loginType: 2, // 使用弹窗登录，和查询报告直接登录区分
          },
          loginDialogProps.loginParams
        )
      )
        .then((res) => {
          showToast('登录成功');
          const token = res ? res.token : undefined;
          token && storage.setItem('token', token, null);
          // 获取用户信息
          getUserDetail().then((resData) => {
            // 登录之后以是否是代理来判断isAgent 展示个人还是代理人
            storage.setItem('isAgentPerson', resData.isAgent, null);
            // loginDialogProps.setIsAgentPerson(resData.isAgent);
            loginDialogProps.toLogin();
          });
          //
          let xyIds = props.agreementList.reduce((pre, cur) => pre + cur.id + ',', '');
          userSignAgreement({
            // signingScene: 5,
            signingScene: '3',
            agreementIds: xyIds.slice(1),
          });
          loginDialogProps.addLoginParams({ registerAgentFlag: 0 });
          isLoadLogin = false;
          // loginDialogProps.setIsLogin(true);
          // loginDialogProps.executeEvent('afterLogin');
          emits('confirm');
          console.log('=========================>getUserInfo', res);
        })
        .catch(() => {
          isLoadLogin = false;
        });
    }
  };

  // 却换tab
  const onClickTab = (item: any) => {
    phone.value = '';
    codeInfo.codeValue = '';
  };
  // 跳转忘记密码页面
  const handlePassword = () => {
    emits('cancelModel');
    router.push('/forgotPassword/forget');
  };

  defineExpose({
    initData: (state = false) => {
      if (!state) {
        phone.value = '';
        initCodeInfo();
        return;
      }
    },
  });
</script>
